import { ProtocolItemModel } from 'shared/domain/inspection/inspectionModel';

/**
 * Find a protocol item by its checklist item ID.
 */
export function findProtocolItemByChecklistItemId(
  protocol: ProtocolItemModel[] | undefined,
  checklistItemId: string
): ProtocolItemModel | undefined {
  return protocol?.find(
    (item) => item.templateChecklistItem === checklistItemId
  );
}

/**
 * Find the protocol item ID by its checklist item ID.
 */
export function findProtocolItemId(
  protocol: ProtocolItemModel[] | undefined,
  checklistItemId: string
): string | undefined {
  return findProtocolItemByChecklistItemId(protocol, checklistItemId)?._id;
}
